import React, { createContext, useContext, useMemo } from 'react';
import type { ConceptTerm } from '../../lookupApi';
import { collectConceptLinks } from './conceptLinks';
import { articleLinker } from './articleLinks';

const Context = createContext<{ content: string; concepts?: ConceptTerm[] } | null>(null);
export function useAnswerConcepts(scope: string) {
    const answer = useContext(Context);
    return useMemo(() => answer ? collectConceptLinks(answer.content, answer.concepts, scope) : null, [answer, scope]);
}

export function useAnswerArticles(scope: string) {
    const answer = useContext(Context);
    return useMemo(() => answer ? articleLinker(answer.content, scope) : null, [answer, scope]);
}

export default function AnswerConcepts({ content, concepts, children }: {
    content: string; concepts?: ConceptTerm[]; children: React.ReactNode;
}) {
    const answer = useMemo(() => ({ content, concepts }), [content, concepts]);
    return <Context.Provider value={answer}>{children}</Context.Provider>;
}
